import {MarketingParams} from "../../../../../common/interfaces/marketing-params.interface";
import {IChannel} from "@sparkware/uc-sdk-core";

export const REGISTRATION_DATA_KEY = 'storeRegistrationData';

export interface IOpenRegistrationOptions {
    channel: IChannel;
    businessCorrelationID?: string;
    marketingParams?: MarketingParams;
}

export interface IRegistrationExternalLinkHandler {
    openRegistration(options?: IOpenRegistrationOptions): Promise<void>;
}